import React, { useEffect, useRef, useState } from 'react'

const AutoRefreshTimer = ({ intervalSeconds = 60, onRefresh, isRefreshing = false }) => {
  const [secondsLeft, setSecondsLeft] = useState(intervalSeconds)
  const onRefreshRef = useRef(onRefresh)
  const isRefreshingRef = useRef(isRefreshing)
  const secondsLeftRef = useRef(intervalSeconds)

  useEffect(() => {
    onRefreshRef.current = onRefresh
  }, [onRefresh])

  useEffect(() => {
    isRefreshingRef.current = isRefreshing
  }, [isRefreshing])

  useEffect(() => {
    secondsLeftRef.current = secondsLeft
  }, [secondsLeft])

  useEffect(() => {
    const tick = setInterval(() => {
      // Held while a refresh (manual or automatic) is in flight, so it never stacks calls.
      if (isRefreshingRef.current) return
      if (secondsLeftRef.current <= 1) {
        setSecondsLeft(intervalSeconds)
        onRefreshRef.current?.()
      } else {
        setSecondsLeft((prev) => prev - 1)
      }
    }, 1000)
    return () => clearInterval(tick)
  }, [intervalSeconds])

  const progress = Math.min(100, ((intervalSeconds - secondsLeft) / intervalSeconds) * 100)

  return (
    <div className="flex-shrink-0 flex items-center gap-2.5 px-4 py-1.5 bg-white/70 dark:bg-gray-900/70 backdrop-blur-sm border-b border-gray-100 dark:border-gray-800/60">
      <span
        className={`material-icons text-gray-400 dark:text-gray-500 flex-shrink-0 ${isRefreshing ? 'animate-spin' : ''}`}
        style={{ fontSize: '17px' }}
      >
        {isRefreshing ? 'sync' : 'schedule'}
      </span>
      <div className="flex-1 min-w-0 h-1 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden">
        <div
          className="h-full rounded-full transition-[width] duration-1000 ease-linear"
          style={{ width: `${progress}%`, backgroundColor: '#1B8A70' }}
        />
      </div>
      <span className="flex-shrink-0 inline-flex items-center justify-center min-w-[30px] px-2 py-0.5 rounded-full text-[10px] font-semibold tabular-nums bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400">
        {secondsLeft}s
      </span>
    </div>
  )
}

export default AutoRefreshTimer
